import LoginPage from 'views/Pages/LoginPage.jsx';
import ForgotPasswordPage from 'views/Pages/ForgotPasswordPage.jsx';
import PasswordResetPage from 'views/Pages/PasswordResetPage.jsx';
import RegisterPage from 'views/Pages/RegisterPage.jsx';
import LockScreenPage from 'views/Pages/LockScreenPage.jsx';
import { AUTH_PATHS } from 'services/AuthService.jsx'

var pagesRoutes = [
    { path: AUTH_PATHS.LOGIN, name: "Login Page", mini: "LP", component: LoginPage },
    { path: AUTH_PATHS.REGISTER, name: "Register", mini: "RP", component: RegisterPage },
    { path: AUTH_PATHS.FORGOT_PASSWORD, name: "Forgot Password", mini: "FP", component: ForgotPasswordPage },
    { path: AUTH_PATHS.PASSWORD_RESET, name: "Password Reset", mini: "PR", component: PasswordResetPage },
    { path: "/pages/lock-screen-page", name: "Lock Screen Page", mini: "LSP", component: LockScreenPage }
];

export default pagesRoutes;



// WEBPACK FOOTER //
// ./src/routes/pages.jsx